<div class="box-container">
  <p>
    Determina el tiempo que Globot volverá a responder si no identifica actividad de parte de ti:
  </p>
  <div class="radio-group">
    <div *ngFor="let option of timeOptions" class="p-field-radiobutton">
      <p-radioButton [value]="option" [(ngModel)]="selectedTime" [inputId]="'time_' + option">
      </p-radioButton>
      <label [for]="'time_' + option" class="ml-2">
        {{ formatTimeOption(option) }}
      </label>
    </div>
  </div>
</div>
<div class="buttons">
  <button class="p-button cancel" (click)="cancelPreferences()">Cancelar</button>
  <button class="p-button p-button-primary" (click)="savePreferences()">Guardar</button>
</div>
